import { render, staticRenderFns } from "./vSeguimientoSoli.vue?vue&type=template&id=28a7e2e0&"
import script from "./vSeguimientoSoli.vue?vue&type=script&lang=js&"
export * from "./vSeguimientoSoli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports